import { Injectable } from '@angular/core'
import { IndividualConfig, ToastrService } from 'ngx-toastr'
import { CoreService } from './core.service'
import { NotificationEvent } from 'depoto-core/src/models/NotificationEvent'
import { TranslateService } from '@ngx-translate/core'

const entityList = [
  'Carrier',
  'Category',
  'CompanyCarrier',
  'Currency',
  'Checkout',
  'Depot',
  'EventType',
  'Parameter',
  'Payment',
  'Producer',
  'Supplier',
  'Tag',
  'Vat',
]

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  avoidErrorAlerts = false
  constructor(
    private toastr: ToastrService,
    private core: CoreService,
    private translateService: TranslateService
  ) {
    this.startListeningToNotifications()
  }

  private startListeningToNotifications() {
    this.core.services.baseEvent.subscribe().then((notificationEvent: NotificationEvent) => {
      if (this.avoidErrorAlerts || this.isStartOfMutation(notificationEvent)) {
        return
      }
      if (this.isResolvedMutation(notificationEvent)) {
        // todo nacte se spravne, jsou data k dispozici?
        // if (entityList.includes(notificationEvent.entity)) {
        // this.core.loadLists() // reload lists on list entity create / update / delete
        // }
      } else if (this.isRejectedMutation(notificationEvent)) {
        this.error(this.getRejectedMutationNotificationText(notificationEvent))
      } else if (this.isRejectedQuery(notificationEvent)) {
        this.error(this.getRejectedQueryNotificationText(notificationEvent))
      }
    })
  }

  private isStartOfMutation(notificationEvent: NotificationEvent): boolean {
    return (
      notificationEvent.type === 'start' &&
      (notificationEvent.operation === 'create' ||
        notificationEvent.operation === 'update' ||
        notificationEvent.operation === 'delete') &&
      notificationEvent.method !== 'createDevLog'
    )
  }

  private isResolvedMutation(notificationEvent: NotificationEvent): boolean {
    return (
      notificationEvent.type === 'resolve' &&
      (notificationEvent.operation === 'create' ||
        notificationEvent.operation === 'update' ||
        notificationEvent.operation === 'delete') &&
      notificationEvent.method !== 'createDevLog'
    )
  }

  private isRejectedMutation(notificationEvent: NotificationEvent): boolean {
    return (
      notificationEvent.type === 'reject' &&
      (notificationEvent.operation === 'create' ||
        notificationEvent.operation === 'update' ||
        notificationEvent.operation === 'delete') &&
      notificationEvent.method !== 'createDevLog'
    )
  }

  private isRejectedQuery(notificationEvent: NotificationEvent): boolean {
    return (
      notificationEvent.type === 'reject' &&
      (notificationEvent.operation === 'list' || notificationEvent.operation === 'detail') &&
      notificationEvent.method !== 'createDevLog'
    )
  }
  /*
  private getMutationNotificationText(notificationEvent: NotificationEvent): string {
    const nameOrNumber =
      notificationEvent.response?.data[notificationEvent.method]?.data?.fullName ||
      notificationEvent.response?.data[notificationEvent.method]?.data?.name ||
      notificationEvent.response?.data[notificationEvent.method]?.data?.billNumber ||
      notificationEvent.response?.data[notificationEvent.method]?.data?.reservationNumber ||
      notificationEvent.response?.data[notificationEvent.method]?.data?.id ||
      ' '
    return 'Úspěšně uloženo.'
    // return `${this.translationPipe.transform(
    //   notificationEvent.entity.toLowerCase(),
    // )} ${nameOrNumber} byl/a úspěšně ${this.translationPipe.transform('notification.' + notificationEvent.operation)}.`
  }
*/
  private getRejectedMutationNotificationText(notificationEvent: NotificationEvent): string {
    const error =
      typeof notificationEvent.errors[0] === 'string'
        ? notificationEvent.errors
        : notificationEvent.errors.map((e: any) => e.message)
    const name = notificationEvent.entity.toLowerCase()
    let result
    switch (notificationEvent.operation) {
      case 'create':
        result = this.translateService.instant('notification.rejected.mutation.creation', { name, error })
        break
      case 'update':
        result = this.translateService.instant('notification.rejected.mutation.update', { name, error })
        break
      case 'delete':
        result = this.translateService.instant('notification.rejected.mutation.deletion', { name, error })
        break
    }
    return result
  }

  private getRejectedQueryNotificationText(notificationEvent: NotificationEvent): string {
    const name = notificationEvent.entity.toLowerCase()
    const errors =
      typeof notificationEvent.errors[0] === 'string'
        ? notificationEvent.errors
        : notificationEvent.errors.map((e: any) => e.message)
    return this.translateService.instant('notification.rejected.query.display', { name, error: errors.join('. ') })
  }

  private getConfig(disableTimeout = false): Partial<IndividualConfig> {
    return {
      positionClass: 'toast-top-center',
      timeOut: disableTimeout ? 0 : 2500,
      extendedTimeOut: disableTimeout ? 0 : 1000,
      disableTimeOut: disableTimeout,
      closeButton: true,
      progressBar: false,
      tapToDismiss: true,
      newestOnTop: false,
    }
  }

  private clamp(value?: string, max = 400): string {
    if (!value) {
      return ''
    }
    return value.length > max ? `${value.slice(0, max)}…` : value
  }

  public warning(text: string, title?: string, disableTimeout = true): void {
    this.toastr.warning(this.clamp(text, 400), this.clamp(title, 40), this.getConfig(disableTimeout))
  }

  public error(text: string, title?: string, disableTimeout = true): void {
    this.toastr.error(this.clamp(text, 400), this.clamp(title, 40), this.getConfig(disableTimeout))
  }

  public success(text: string, title?: string, disableTimeout = false): void {
    this.toastr.success(this.clamp(text, 400), this.clamp(title, 40), this.getConfig(disableTimeout))
  }

  public info(text: string, title?: string, disableTimeout = false): void {
    this.toastr.info(this.clamp(text, 400), this.clamp(title, 40), this.getConfig(disableTimeout))
  }
}
